import React from 'react';
export var Layout = function Layout(_ref) {
  var children = _ref.children;
  return React.createElement("div", {
    style: {
      width: '100%',
      maxWidth: '1440px',
      margin: '0 auto'
    }
  }, children);
};